const frontendproff = [
  "CSS3",
  "HTML5",
  "jQuery",
  "React",
  "REST APIs",
  "Javascript",
  "Responsive Design",
  "Handlebars",
  "Bootstrap",
  "Redux",
  "UIkit",
  "Jest",
];

export default frontendproff;
